import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";
import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";

export default function ModalLueftungFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);
    
    const lueftung_future = useStore((state)=>state.lueftung_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("ventilation_system",lueftung_future);
    },[lueftung_future]);
    
  return (<Panel >
            <h1>Welche neue Lüftung ist geplant?</h1>
            <PropertyInput type="lueftung_future"/>
            <PropertyInput type="lueftung_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["ventilation_system"].total_costs)  + " €"}/>
            
            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                close_menu();
                init_property_if_undefined("lueftung_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

